export const USER_AGENT = "user-agent";
export const X_AMZ_USER_AGENT = "x-amz-user-agent";
export const SPACE = " ";
export const UA_NAME_SEPARATOR = "/";
export const UA_NAME_ESCAPE_REGEX = /[^\!\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;
export const UA_VALUE_ESCAPE_REGEX = /[^\!\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w\#]/g;
export const UA_ESCAPE_CHAR = "-";
